import React from 'react';
import { Trophy } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * AchievementsTab - Display user achievements and badges
 *
 * Currently a placeholder for future achievement system
 */
export default function AchievementsTab() {
  const { theme } = useTheme();

  return (
    <div className="text-center py-12">
      <Trophy className="w-16 h-16 text-gray-400 mx-auto mb-4" />
      <h3 className={`text-lg font-medium ${theme.text} mb-2`}>Achievement System Coming Soon</h3>
      <p className={`${theme.textSecondary}`}>Track your progress and unlock badges as you play!</p>
    </div>
  );
}
